import { CircularProgress, Paper, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

interface StyledProps {
  isFullScreen: boolean;
  loading: boolean;
}

const StyledPaper = styled(Paper, {
  shouldForwardProp: prop => prop !== 'isFullScreen' && prop !== 'loading',
})<StyledProps>(({ theme, isFullScreen, loading }) => ({
  display: loading ? 'block' : 'none',
  padding: isFullScreen ? '0px' : `${theme.spacing(8)} ${theme.spacing(4)}`,
  minWidth: '500px',
  textAlign: 'center',
  position: 'relative',
  width: isFullScreen ? '100%' : 'auto',
  height: isFullScreen ? '100%' : 'auto',
}));

const StyledCircularProgress = styled(CircularProgress, {
  shouldForwardProp: prop => prop !== 'isFullScreen',
})<{ isFullScreen: boolean }>(({ isFullScreen }) => ({
  position: isFullScreen ? 'absolute' : 'relative',
  top: isFullScreen ? '50%' : 'auto',
  left: isFullScreen ? '50%' : 'auto',
  marginTop: isFullScreen ? '-25px' : '0',
  marginLeft: isFullScreen ? '-25px' : '0',
}));

const StyledLoadingMessage = styled(Typography)(({ theme }) => ({
  marginTop: theme.spacing(2),
  width: '100%',
  textAlign: 'center',
}));

export { StyledPaper, StyledCircularProgress, StyledLoadingMessage };
